module.exports = __webpack_public_path__ + "static/media/cabinet-maker.afdae9a1.jpg";